import {useEffect, useState} from 'react'

const useObjectUrlFromFile = (file: File | undefined) => {
  const [objectURL, setObjectURL] = useState<string | undefined>()
  useEffect(() => {
    if (!file) return
    const objectURL = URL.createObjectURL(file)
    setObjectURL(objectURL)
    return () => {
      URL.revokeObjectURL(objectURL)
      setObjectURL(undefined)
    }
  }, [file, setObjectURL])
  return objectURL
}

export default useObjectUrlFromFile
